import useApplicationDetails from 'screens/Applications&WorkOrders/Applications/Hooks/useApplicationDetails';

const useDrawerApplicationDetails = (applicationId: string | null) => {
  const {
    applicationDetails,
    isLoading,
    errors,
    refetch
  } = useApplicationDetails(applicationId);

  return {
    applicationDetails,
    isLoading,
    error: errors,
    refetch
  };
};

export default useDrawerApplicationDetails;
